import * as routes from './routeComponents'
import { isItAccess } from '../constants/Roles'

// More specific destinations precede their parent, just as they do in App's Switch.
const destinations = [
    ['/management/upload_user_data', 'UploadEngineScreen'],
    ['/management/upload', 'UploadUserDataScreen'],
    ['/management', 'ManagementHome'],
    ['/content/surveys', 'CreateSurvey'],
    ['/content/program', 'ContentProgram'],
    ['/content', 'Content'],
    ['/readytogo', 'ReadyToGo'],
    ['/classroom', 'ClassroomHome'],
    ['/chat', 'Chat'],
    ['/catch-up', 'CatchUpHome'],
    ['/counseling/student_profile', 'StudentWellbeingProfile'],
    ['/counseling', 'CounselingHome'],
    ['/settings', 'Settings'],
    ['/videos', 'InstructionVideos'],
    ['/analytics/search', 'AnalyticsSearch'],
    ['/analytics/student', 'StudentAnalyticsHome'],
    ['/analytics/class', 'ClassAnalyticsHome'],
    ['/analytics/year', 'YearAnalyticsHome'],
    ['/analytics/counsellor', 'CounsellorAnalyticsHome'],
    ['/analytics/organization', 'OrganizationAnalyticsHome'],
    ['/analytics/custom-report', 'ManageCustomReports'],
    ['/analytics/data', 'AnalyzeContent'],
    ['/analytics/pulse', 'PulseCheckScreen'],
    ['/analytics', 'AnalyticsHome'],
    ['/early/dashboard', 'EarlyDashboard'],
    ['/early/classroom/student-select-emotion', 'StudentSelectEmotionScreen'],
    ['/early/classroom/student-settings', 'StudentsSettingsScreen'],
    ['/early/classroom', 'EarlyClassroomHome'],
    ['/alerts/notification', 'NotificationsHome'],
    ['/alerts', 'AlertsHome'],
    ['/inactivity', 'ManagementHome'],
    ['/onboarding', 'OnboardingScreen'],
    ['/no-permission', 'NoPermission'],
]

const matches = (path, prefix) => path === prefix || path.startsWith(`${prefix}/`)

export function routeForPreload(path, { user, primaryUI }) {
    if (isItAccess(user) && !['/management', '/settings', '/no-permission'].some(prefix => matches(path, prefix))) return null
    if (matches(path, '/analytics/organization') && !user?.allowedToAccessOrganizationAnalytics) return null
    if (matches(path, '/alerts/notification') && !(user?.role == 'school_admin' || user?.role_coverage?.target_text == 'All students')) return null
    if (matches(path, '/dashboard') || path === '/') return primaryUI ? routes.EarlyDashboard : routes.Dashboard
    const destination = destinations.find(([prefix]) => matches(path, prefix))
    return destination ? routes[destination[1]] : null
}

export function reachableRouteComponents(root, context, currentUrl) {
    const components = new Set()
    const current = new URL(currentUrl)
    for (const element of root.querySelectorAll('a[href], [data-preload-route]')) {
        if (element.matches('[disabled], [aria-disabled="true"], [download]')) continue
        const href = element.getAttribute('data-preload-route') || element.getAttribute('href')
        if (!href || href.startsWith('#')) continue
        let url
        try { url = new URL(href, current) } catch { continue }
        if (url.origin !== current.origin) continue
        const mode = element.getAttribute('data-preload-mode')
        const routeContext = mode ? { ...context, primaryUI: mode === 'primary' } : context
        const component = routeForPreload(url.pathname.replace(/\/+$/, '') || '/', routeContext)
        const currentComponent = routeForPreload(current.pathname.replace(/\/+$/, '') || '/', context)
        if (component && component !== currentComponent) components.add(component)
    }
    return [...components]
}
